/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
  "data": {
    "day": {
      "-1": "हिजो",
      "-2": "अस्ति",
      "0": "आज",
      "1": "भोलि",
      "2": "पर्सि",
      "future": {
        "one": "{0} दिनमा",
        "other": "{0} दिनमा"
      },
      "past": {
        "one": "{0} दिन पहिले",
        "other": "{0} दिन पहिले"
      }
    },
    "day-narrow": {
      "-1": "हिजो",
      "-2": "अस्ति",
      "0": "आज",
      "1": "भोलि",
      "2": "पर्सि",
      "future": {
        "one": "{0} दिनमा",
        "other": "{0} दिनमा"
      },
      "past": {
        "one": "{0} दिन पहिले",
        "other": "{0} दिन पहिले"
      }
    },
    "day-short": {
      "-1": "हिजो",
      "-2": "अस्ति",
      "0": "आज",
      "1": "भोलि",
      "2": "पर्सि",
      "future": {
        "one": "{0} दिनमा",
        "other": "{0} दिनमा"
      },
      "past": {
        "one": "{0} दिन पहिले",
        "other": "{0} दिन पहिले"
      }
    },
    "hour": {
      "0": "यस घडीमा",
      "future": {
        "one": "{0} घण्टामा",
        "other": "{0} घण्टामा"
      },
      "past": {
        "one": "{0} घण्टा पहिले",
        "other": "{0} घण्टा पहिले"
      }
    },
    "hour-narrow": {
      "0": "यस घडीमा",
      "future": {
        "one": "{0} घण्टामा",
        "other": "{0} घण्टामा"
      },
      "past": {
        "one": "{0} घण्टा पहिले",
        "other": "{0} घण्टा पहिले"
      }
    },
    "hour-short": {
      "0": "यस घडीमा",
      "future": {
        "one": "{0} घण्टामा",
        "other": "{0} घण्टामा"
      },
      "past": {
        "one": "{0} घण्टा पहिले",
        "other": "{0} घण्टा पहिले"
      }
    },
    "minute": {
      "0": "यही मिनेटमा",
      "future": {
        "one": "{0} मिनेटमा",
        "other": "{0} मिनेटमा"
      },
      "past": {
        "one": "{0} मिनेट पहिले",
        "other": "{0} मिनेट पहिले"
      }
    },
    "minute-narrow": {
      "0": "यही मिनेटमा",
      "future": {
        "one": "{0} मिनेटमा",
        "other": "{0} मिनेटमा"
      },
      "past": {
        "one": "{0} मिनेट पहिले",
        "other": "{0} मिनेट पहिले"
      }
    },
    "minute-short": {
      "0": "यही मिनेटमा",
      "future": {
        "one": "{0} मिनेटमा",
        "other": "{0} मिनेटमा"
      },
      "past": {
        "one": "{0} मिनेट पहिले",
        "other": "{0} मिनेट पहिले"
      }
    },
    "month": {
      "-1": "गत महिना",
      "0": "यो महिना",
      "1": "अर्को महिना",
      "future": {
        "one": "{0} महिनामा",
        "other": "{0} महिनामा"
      },
      "past": {
        "one": "{0} महिना पहिले",
        "other": "{0} महिना पहिले"
      }
    },
    "month-narrow": {
      "-1": "गत महिना",
      "0": "यो महिना",
      "1": "आगामी महिना",
      "future": {
        "one": "{0} महिनामा",
        "other": "{0} महिनामा"
      },
      "past": {
        "one": "{0} महिना पहिले",
        "other": "{0} महिना पहिले"
      }
    },
    "month-short": {
      "-1": "गत महिना",
      "0": "यो महिना",
      "1": "आगामी महिना",
      "future": {
        "one": "{0} महिनामा",
        "other": "{0} महिनामा"
      },
      "past": {
        "one": "{0} महिना पहिले",
        "other": "{0} महिना पहिले"
      }
    },
    "nu": [
      "deva"
    ],
    "quarter": {
      "-1": "अघिल्लो सत्र",
      "0": "यो सत्र",
      "1": "अर्को सत्र",
      "future": {
        "one": "+{0} सत्रमा",
        "other": "{0}सत्रमा"
      },
      "past": {
        "one": "{0}सत्र अघि",
        "other": "{0}सत्र अघि"
      }
    },
    "quarter-narrow": {
      "-1": "अघिल्लो सत्र",
      "0": "यो सत्र",
      "1": "अर्को सत्र",
      "future": {
        "one": "{0}सत्रमा",
        "other": "{0}सत्रमा"
      },
      "past": {
        "one": "{0}सत्र अघि",
        "other": "{0}सत्र अघि"
      }
    },
    "quarter-short": {
      "-1": "अघिल्लो सत्र",
      "0": "यो सत्र",
      "1": "अर्को सत्र",
      "future": {
        "one": "{0}सत्रमा",
        "other": "{0}सत्रमा"
      },
      "past": {
        "one": "{0}सत्र अघि",
        "other": "{0}सत्र अघि"
      }
    },
    "second": {
      "0": "अहिले",
      "future": {
        "one": "{0} सेकेन्डमा",
        "other": "{0} सेकेन्डमा"
      },
      "past": {
        "one": "{0} सेकेन्ड पहिले",
        "other": "{0} सेकेन्ड पहिले"
      }
    },
    "second-narrow": {
      "0": "अहिले",
      "future": {
        "one": "{0} सेकेन्डमा",
        "other": "{0} सेकेन्डमा"
      },
      "past": {
        "one": "{0} सेकेन्ड पहिले",
        "other": "{0} सेकेन्ड पहिले"
      }
    },
    "second-short": {
      "0": "अहिले",
      "future": {
        "one": "{0} सेकेन्डमा",
        "other": "{0} सेकेन्डमा"
      },
      "past": {
        "one": "{0} सेकेन्ड पहिले",
        "other": "{0} सेकेन्ड पहिले"
      }
    },
    "week": {
      "-1": "गत हप्ता",
      "0": "यो हप्ता",
      "1": "आउने हप्ता",
      "future": {
        "one": "{0} हप्तामा",
        "other": "{0} हप्तामा"
      },
      "past": {
        "one": "{0} हप्ता पहिले",
        "other": "{0} हप्ता पहिले"
      }
    },
    "week-narrow": {
      "-1": "गत हप्ता",
      "0": "यो हप्ता",
      "1": "आगामी हप्ता",
      "future": {
        "one": "{0} हप्तामा",
        "other": "{0} हप्तामा"
      },
      "past": {
        "one": "{0} हप्ता पहिले",
        "other": "{0} हप्ता पहिले"
      }
    },
    "week-short": {
      "-1": "गत हप्ता",
      "0": "यो हप्ता",
      "1": "आगामी हप्ता",
      "future": {
        "one": "{0} हप्तामा",
        "other": "{0} हप्तामा"
      },
      "past": {
        "one": "{0} हप्ता पहिले",
        "other": "{0} हप्ता पहिले"
      }
    },
    "year": {
      "-1": "गत वर्ष",
      "0": "यो वर्ष",
      "1": "आगामी वर्ष",
      "future": {
        "one": "{0} वर्षमा",
        "other": "{0} वर्षमा"
      },
      "past": {
        "one": "{0} वर्ष अघि",
        "other": "{0} वर्ष अघि"
      }
    },
    "year-narrow": {
      "-1": "गत वर्ष",
      "0": "यो वर्ष",
      "1": "आगामी वर्ष",
      "future": {
        "one": "{0} वर्षमा",
        "other": "{0} वर्षमा"
      },
      "past": {
        "one": "{0} वर्ष अघि",
        "other": "{0} वर्ष अघि"
      }
    },
    "year-short": {
      "-1": "गत वर्ष",
      "0": "यो वर्ष",
      "1": "आगामी वर्ष",
      "future": {
        "one": "{0} वर्षमा",
        "other": "{0} वर्षमा"
      },
      "past": {
        "one": "{0} वर्ष अघि",
        "other": "{0} वर्ष अघि"
      }
    }
  },
  "locale": "ne-IN"
})
}
